import React from 'react';
import { useIntl } from 'react-intl';

import { getMarketingTagIcon } from '@swf/casino';
import fsbIcon from '@swf/core/assets/casino/freeSpin-icon-sm.png';

import { TXTCLI_Free_Spins } from './MarketingIcon.messages.json';

interface Prop {
  fsb?: boolean;
  disableIcons?: boolean;
  tags?: string[];
  styles: { fsbIcon: string; marketingIcon: string };
}

const MarketingIcon: React.FC<Prop> = ({ fsb, disableIcons, tags, styles }) => {
  const { formatMessage } = useIntl();
  const marketingIcon: string = tags ? getMarketingTagIcon(tags) : '';
  const imgSrc: string = fsb ? (fsbIcon as string) : marketingIcon;

  if (!imgSrc || (!fsb && disableIcons && !tags)) return null;

  return (
    <img
      src={imgSrc}
      className={fsb ? styles.fsbIcon : styles.marketingIcon}
      alt={fsb ? formatMessage(TXTCLI_Free_Spins) : ''}
    />
  );
};

export default MarketingIcon;
